import Vue from "vue";
import axios from "axios";
import VueToast from "vue-toast-notification";
import JwtService from "@/core/services/jwt.service";
import { SYSTEM_VARIABLE } from "../modules/Application";

Vue.use(VueToast, {
  position: "top-right",
  duration: 8000
});

const normalizeText = value =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const getFriendlyDeviceLimitMessage = payload => {
  const contracted = Number(
    payload?.contracted_quantity ??
      payload?.installed_quantity ??
      payload?.max_quantity ??
      payload?.total_quantity ??
      0
  );
  const used = Number(
    payload?.used_quantity ?? payload?.current_quantity ?? contracted ?? 0
  );

  if (contracted > 0) {
    return `Limite de PDVs Offline atingido. Sua empresa possui ${used} de ${contracted} terminais contratados. Acesse Apps para contratar mais PDVs.`;
  }

  return "Limite de PDVs Offline atingido. Acesse Apps para contratar mais PDVs.";
};

const isDeviceLimitError = payload => {
  const message = normalizeText(payload?.message || payload?.msg);
  const code = normalizeText(payload?.code || payload?.error || payload?.type);

  const hasLimitSignal =
    message.includes("limite") ||
    message.includes("maximo") ||
    message.includes("atingido") ||
    code.includes("limit");

  const hasDeviceSignal =
    message.includes("checkdevice") ||
    message.includes("device") ||
    message.includes("terminal") ||
    message.includes("pdv") ||
    code.includes("device") ||
    code.includes("terminal") ||
    code.includes("pdv");

  return hasLimitSignal && hasDeviceSignal;
};

const isUserLimitError = payload => {
  const message = normalizeText(payload?.message || payload?.msg);
  const featureCode = normalizeText(payload?.feature_code);

  return (
    featureCode === "plg_usuarios_extra" ||
    (message.includes("limite") &&
      message.includes("usuario") &&
      message.includes("marketplace"))
  );
};

export const httpResetLogin = axios.create({
  baseURL: `${SYSTEM_VARIABLE.BASE_URL_API}/api`,
  headers: {
    Accept: "application/json"
  }
});

export const http = axios.create({
  baseURL: `${SYSTEM_VARIABLE.BASE_URL_API}/api`,
  headers: {
    Accept: "application/json"
  }
});

http.interceptors.request.use(async config => {
  let token = await JwtService.getToken();

  if (await JwtService.getTokenCliente()) {
    token = await JwtService.getTokenCliente();
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`
    },
  };
});

http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const response = error?.response;
    const payload = response?.data || {};

    if (!response) {
      return Promise.reject(error);
    }

    if (response.status == 401) {
      Vue.$toast.error(`É necessário estar logado!`);
      window.location.href = `/#/login`;
    }

    if (isDeviceLimitError(payload)) {
      const message = getFriendlyDeviceLimitMessage(payload);
      Vue.$toast.error(message);

      const shouldRedirect = window.confirm(
        `${message}\n\nDeseja ir para o Marketplace agora?`
      );

      if (shouldRedirect) {
        window.location.href = "/#/apps";
      }

      return Promise.reject(error);
    }

    if (isUserLimitError(payload)) {
      return Promise.reject(error);
    }

    if (payload.message) {
      Vue.$toast.error(payload.message);
    }

    if (payload.msg) {
      Vue.$toast.error(payload.msg);
    }

    if (payload.errors) {
      const errors = Object.entries(payload.errors);

      errors.forEach(element => {
        element[1].forEach(e => {
          Vue.$toast.error(e);
        });
      });
    }
    return Promise.reject(error);
  }
);

httpResetLogin.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const payload = error?.response?.data || {};

    if (payload.msg) {
      Vue.$toast.error(payload.msg);
    }

    if (payload.errors) {
      const errors = Object.entries(payload.errors);

      errors.forEach(element => {
        element[1].forEach(e => {
          Vue.$toast.error(e);
        });
      });
    }
    return Promise.reject(error);
  }
);
